import React from "react";

const GVAccordionMinus: React.FC = props => {
    return (
        <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.575 0H14.575C14.875 0 15.15 0.25 15.15 0.55C15.15 0.875 14.875 1.125 14.575 1.125H0.575C0.275 1.125 0 0.875 0 0.55C0 0.25 0.275 0 0.575 0Z" fill="#111928"/>
        </svg>
    );
};

export default React.memo(GVAccordionMinus);